/** Shift（ダッシュ修飾キー）。左右どちらでも有効。 */
export const DASH_KEYS = new Set(['ShiftLeft', 'ShiftRight'])

/** WASD と矢印キーの押下状態を管理するキー集合。 */
export const MOVEMENT_KEYS = new Set([
  'ArrowUp',
  'ArrowDown',
  'ArrowLeft',
  'ArrowRight',
  'KeyW',
  'KeyS',
  'KeyA',
  'KeyD',
])

/** 矢印キーはページスクロールを誘発するため preventDefault 対象。 */
export const ARROW_KEYS = new Set([
  'ArrowUp',
  'ArrowDown',
  'ArrowLeft',
  'ArrowRight',
])

/**
 * 押下キー集合から XZ 平面の移動方向（未正規化）を求める。
 * キーボードと仮想キー（キーガイドのタップ）は別集合で管理されるため、
 * 両方を見て合成する（同じキーを別ソースで押しても片方の解放で消えない）。
 */
export const directionFromKeys = (
  held: ReadonlySet<string>,
  virtualHeld: ReadonlySet<string>,
): { x: number; z: number } => {
  const has = (code: string): boolean => held.has(code) || virtualHeld.has(code)
  let x = 0
  let z = 0
  // Z- を「奥（前）」、X- を「左」とする three/World と同じ右手 Y-up 座標系。
  // 方向キーの左右は Roblox 本家に合わせて視点回転（threeRenderer が担当）で、
  // 横移動には使わない（横移動は A/D のみ。乗車中の操舵は vehicleSystem が
  // ArrowLeft/Right を直接読む）。
  if (has('ArrowUp') || has('KeyW')) z -= 1
  if (has('ArrowDown') || has('KeyS')) z += 1
  if (has('KeyA')) x -= 1
  if (has('KeyD')) x += 1
  return { x, z }
}
